var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.show)?_c('vs-table',{attrs:{"params":_vm.params,"options":_vm.options},on:{"onCreateHeaderActionClicked":function($event){return _vm.openOrderDetail('create',0,2)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }